import React from 'react';
import LinkableTitle from './linkableTitle';
import remark from 'remark';
import html from 'remark-html';

import { Popover } from 'module-tsl-ui-elements';

const NAMES_MAP = {
  'union': 'oneOfType',
  'enum': 'oneOf'
}

const mapName = (name) => NAMES_MAP[name] || name;

const getRequiredKeys = (props) => Object.keys(props).filter(key => props[key].required)
const getNotRequiredKeys = (props) => Object.keys(props).filter(key => !props[key].required)

const renderRecursively = (val) => `${val.name} ${Array.isArray(val.value)
  ? `(${val.value.map(renderRecursively).join(', ')})`
  : val.value ? `(${val.value.name})` : ''}`;

class PropsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      data: {
        props: {},
      },
    }
  }

  async componentDidMount() {
    const { data } = this.props;
    if (data && data.props) {
      const newData = {};
      await Promise.all(Object.keys(data.props).map(async (propName) => {
        const prop = data.props[propName];
        if (!!prop.description) {
          const { contents: description } = await remark().use(html).process(prop.description);
          prop.description = description; // yes, side effects, but it's the styleguide 🤷‍♂️
        }
        newData[propName] = prop;
      }));
      this.setState({ loaded: true, data: { props: newData } });
    }
  }
  
  render() {
    const { data, loaded } = this.state;
    return (
      <div className="page-content-propstable">
      <LinkableTitle name="props" title="Props" />
      {data && data.props && loaded
        ? (
          <table className="props-table">
            <thead className="props-table__thead">
              <tr>
                <th className="props-table__heading">Prop name</th>
                <th className="props-table__heading">Type</th>
                <th className="props-table__heading">Default</th>
                <th className="props-table__heading">Required</th>
                <th className="props-table__heading">Description</th>
              </tr>
            </thead>
            <tbody>
              {[...getRequiredKeys(data.props),
                ...getNotRequiredKeys(data.props)].map((propName) => {
                const prop = data.props[propName];
                return (
                  <tr key={propName}>
                    <td className="props-table__cell">
                      <code className="props-table__name">{propName}</code>
                    </td>
                    <td className="props-table__cell props-table__cell__type">
                      <span className="props-table__type">{mapName(prop.type.name)}</span>
                      {Array.isArray(prop.type.value) && prop.type.name === 'union' &&
                        <span className="props-table__type__value">{prop.type.value.map(renderRecursively).join(', ')}</span>
                      }
                      {Array.isArray(prop.type.value) && prop.type.name === 'enum' &&
                        <span className="props-table__type__value">{prop.type.value.map(val => val.value).join(', ')}</span>
                      }
                      {typeof prop.type.value === 'string' &&
                        <span className="props-table__type__value">{prop.type.value}</span>
                      }
                      {typeof prop.type.value === 'object' && typeof prop.type.value.name === 'string' &&
                        <span className="props-table__type__value">{prop.type.value.name}</span>
                      }
                      {prop.type.computed &&
                        <Popover tooltipBehavior content="check the component">
                          <span><b>computed</b></span>
                        </Popover>
                      }
                    </td>
                    <td className="props-table__cell props-table__cell__code">
                      <span>{prop.defaultValue ? prop.defaultValue.value : ''}</span>
                    </td>
                    <td className="props-table__cell">
                      <span className="props-table__required__value">{prop.required ? <i className="icon icon-required" /> : ''}</span>
                    </td>
                    <td className="props-table__cell">
                      <span dangerouslySetInnerHTML={{ __html: prop.description }} />
                    </td>
                  </tr>
              )})}
            </tbody>
          </table>
        ) : <div><small>We couldn't detect props! Check if __docgenInfo is correctly defined</small></div>
      }
    </div>
    );
  }
};

export default PropsTable;